import React from 'react';
import PasswordReset from "./views/pages/PasswordReset";
import CartScreen from "./views/pages/CartScreen";
import Payment from "./views/pages/Payment";

const light = React.lazy(() => import(/* webpackChunkName: "light" */ './views/pages/Light'));
const dark = React.lazy(() => import(/* webpackChunkName: "dark" */ './views/pages/Dark'));
const user = React.lazy(() => import(/* webpackChunkName: "user" */ './views/pages/User'));


// one Route per theme (paths most specific first): separate Routes would remount the page on every
// /light <-> /light/:page switch, killing the open/close animation and the navigation state
const routes = [
  { path: ['/light/:page/:type/:room/:id', '/light/:page/:type/:id', '/light/:page/:id', '/light/:page', '/light'], name: 'main', component: light },
  { path: ['/dark/:page/:id', '/dark/:page', '/dark'], name: 'main', component: dark },
  { path: ['/user/:page', '/user'], name: 'User', component: user },
  { path: '/password/change/:token',  name: 'Password Reset', component: PasswordReset },
  { path: '/cart',  name: 'Cart', component: CartScreen },
  { path: '/pay/:status/:uuid',  name: 'Payment',exact:true, component: Payment },
  { path: '/pay/:status/:uuid/:platform',  name: 'Payment', component: Payment },
];

export default routes;



